export const MONTHS_SHORT = [
  "Jan", "Fév", "Mar", "Avr", "Mai", "Juin",
  "Juil", "Août", "Sep", "Oct", "Nov", "Déc",
];

/**
 * Formate une borne de date CV (mois optionnel + année) en texte court, ex: "Mars 2021".
 */
export function formatCvBound(year, month) {
  if (!year) return "";
  return month ? `${MONTHS_SHORT[month - 1]} ${year}` : `${year}`;
}

/**
 * Formate une période complète d'entrée de CV, ex: "Mars 2021 - Présent" ou "2018 - 2020".
 */
export function formatCvPeriod({ start_year, start_month, end_year, end_month, is_ongoing }) {
  const start = formatCvBound(start_year, start_month);
  const end = is_ongoing ? "Présent" : formatCvBound(end_year, end_month);
  return `${start} - ${end}`;
}
